import React, {useState, useEffect}from 'react';
import {Link, Redirect, useHistory} from 'react-router-dom'
//COMPONENTS
import CustomButton from '../atoms/CustomButton';
import InputFormLog from '../atoms/inputFormLog';
import {LoginServiceCenter} from '../../api/DewaltServices'
import Swal from 'sweetalert2'
import LoadingOver from '../atoms/LoadingOver';
import AuthStateContext from '../../context/AuthContext';
//API
import AuthService from "../../api/AuthService";

// CSS
import '../styles/login.css'
import '../../constants/Global.css'

var AuthState = '';

export default function FormLog (props){
    let history = useHistory();
    const [openLogin, setOpenLogin] = useState(false);
    const [logged, setLogged] = useState(()=>{
        try{
            const loggedIn = window.localStorage.getItem('loggedIn')
            return loggedIn;
        }catch(e){
            return false
        }
    });
    const [userDate, setUserDate] = useState({
        usuario: '',
        password: ''
    })
    const [loginServiceCenter, setLoginServiceCenter] = useState(()=>{
        try{
            const Auth = window.localStorage.getItem('UserLogged')
            return Auth;
        }catch(e){
            return false
        }
    });

    const [LinkLog, setLinkLog] = useState('')
    const [loading, setLoading] = useState(false)
    
    // Add ref to track if component is mounted
    const isMountedRef = React.useRef(true);
    
    useEffect(() => {
        // Component is mounted
        isMountedRef.current = true;
        
        // Cleanup function
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    
    const handleChange= (event)=>{
        // Only update state if component is still mounted
        if (isMountedRef.current) {
            setUserDate({
                ...userDate,
                [event.target.name] : event.target.value
            })
        }
    }

    const alertWrongGet = ()=>{
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Error: Usuario o contraseña equivocados',
        })
    }

    //Se guarda la variable del login
    const setLocalStorage = value =>{
        try{
            window.localStorage.setItem('loggedIn', value)
            // Only update state if component is still mounted
            if (isMountedRef.current) {
                setLogged(value)
            }
        }catch(e){
            console.log(e)
        }
    }
    const setLocalData= value =>{
        try{
            window.localStorage.setItem('UserLogged', value)
            // Only update state if component is still mounted
            if (isMountedRef.current) {
                setLoginServiceCenter(value)
            }
        }catch(e){
            console.log(e)
        }
    }

    const loginService = async (usuario,password) =>{

        if (!isMountedRef.current) return; // Don't proceed if component is unmounted
        
        setOpenLogin(!openLogin)
        try{
            LoginServiceCenter(usuario,password)
            const response = LoginServiceCenter(usuario,password);
            const data = (await response).data;
            
            // Check if component is still mounted before updating state
            if (!isMountedRef.current) return;
            
            setLocalData(`${data.result.social_reason}`)
            
            // Also store the service center ID
            if (data.result.id) {
                try {
                    window.localStorage.setItem('ServiceCenterId', data.result.id);
                } catch(e) {
                    console.log('Error storing service center ID:', e);
                }
            }
            
            if (data){
                // Auth = true;
                setLocalStorage(true);

                <AuthStateContext.Provider value={true}>
                    {history.push('/Orders')}
                </AuthStateContext.Provider>
                
                // setLinkLog("/Orders")
                //return <Redirect to={"/Orders"} />
                
            }
            return(data)
        }catch(error){
            // Check if component is still mounted before updating state
            if (!isMountedRef.current) return;
            
            // Auth = false;
            setLocalStorage(false);

            console.log("error Login")
            alertWrongGet()
            setLinkLog("/")
            
            console.log(error.response)
        }finally{
            // Check if component is still mounted before updating state
            if (isMountedRef.current) {
                setOpenLogin(false)
            }
        }   
        // console.log(response)
    }   

        return(
            <div>
                    <h2 className="h2-stl">{props.label}</h2>
                    <div className="EmptySpaceSmall"></div>
                    <div>
                        <InputFormLog 
                            type        = "text"
                            name        = "usuario"
                            id          = "Usuario_LoginPage"
                            placeholder = "Usuario"
                            change      = {handleChange}
                            style       =  {{fontSize: "25px"}}
    
                        />
                        <div className="EmptySpaceSmall" ></div>
                        <InputFormLog   
                            type        = "password"
                            name        = "password"
                            id          = "pass_LoginPage"
                            placeholder = "Contraseña"
                            change      = {handleChange}
                            style       =  {{fontSize: "25px"}}
                        />  
                    </div>
                    <div className="EmptySpaceSmall" ></div>
                        <CustomButton 
                        
                                variant     =   "outlined" 
                                background  =   "#C4C4C4" 
                                color       =   "#FFFFFF"
                                width       =   "356px"
                                heigth      =   "57px"
                                fontSize    =   "24px"
                                label       =   "INICIAR SESIÓN"
                                link        =   {LinkLog}
                                // link        =   "/Orders"
                                action      =   {()=>{loginService(userDate.usuario,userDate.password)}}        //ver funcion
                        />
                    <div className="py-2"></div>
                        <div className="row">
                            <div className = "col-5"></div>
                    
                            <div className = "col-5"></div>
                        </div>
                        <LoadingOver
                            open = {openLogin}
                        />      
            </div>
        );
    
}


export function authState (){
    return AuthState;
}

